export default {
    tenants: (state) => state.tenants,
    tenantCode: (state) => state.tenantCodeSelected,
    websiteS3: (state) => state.websiteS3,
    selectedWebsiteS3: (state) => state.selectedWebsiteS3,
    mailSender: (state) => state.mailSender,
    selectedmailSender: (state) => state.selectedmailSender,
    tenant:(state) => state.tenant
}
